import React, { useState } from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import { useJiraContext } from 'src/services/jira';
import { useLinkedIncident } from 'src/services/linkedIncident';

import { trackEvent } from 'src/lib/analytics';
import jira from 'src/lib/api/jira';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';

import { findExternalReference, unlink } from './unlinkImpl';

const analyticsEventName = 'sidebar_incidentresponse_unlink_incident';
const ConfirmationView = () => {
  const jiraContext = useJiraContext();
  const linkedIncident = useLinkedIncident();

  const [submitting, setSubmitting] = useState(false);
  const [{ errorMessage, successMessage }, setError] = useState({});
  const { bySidebarInfo, byId, byService } = linkedIncident;
  const loading = [bySidebarInfo, byId, byService].some(x => x.loading);

  if (jiraContext.error) return <ErrorMessage error={jiraContext.error}/>;
  if (loading || !jiraContext.context) return <CenteredSpinner size="large"/>;

  const { context: { issueKey } } = jiraContext;

  if (!linkedIncident.incident) {
    return <ErrorMessage error="Can not find linked incident"/>;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    trackEvent(analyticsEventName, { label: 'unlink_incident' });
    unlink(linkedIncident, issueKey)
      .then(({ errorMessage, successMessage }) => {
        if (!errorMessage) jira.closeCurrentModal();
        setError({ errorMessage, successMessage });
        setSubmitting(false);
      });
  };

  const closeModal = () => {
    trackEvent(analyticsEventName, { label: 'cancel' });
    jira.closeCurrentModal();
  };

  return (
    <div style={{ display: 'flex', flexFlow: 'column nowrap', minHeight: '210px' }}>
      {
        ((bySidebarInfo && bySidebarInfo.incident) || findExternalReference(issueKey, byId.incident))
        && <div data-cy="info-message"><SectionMessage>
          External reference will be removed from PagerDuty
        </SectionMessage></div>
      }
      <br/>
      {
        byId && byId.incident
        && <div data-cy="info-message"><SectionMessage>
          PagerDuty issue property will be removed from issue
        </SectionMessage></div>
      }
      <br/>
      {
        byService && byService.incident
        && <div data-cy="info-message"><SectionMessage>
          Issue will be unlinked.
        </SectionMessage></div>
      }

      <div style={{ flexGrow: 1, minHeight: 30 }}/>

      {
        successMessage
        && <div data-cy="info-message"><SectionMessage title="Partial success">
          {successMessage}
        </SectionMessage></div>
      }

      {errorMessage && <ErrorMessage error={['Failed to unlink incident', errorMessage]}/> }

      <div style={{ paddingTop: 24, paddingBottom: 24, display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonGroup>
          <Button onClick={closeModal}>Cancel</Button>
          <LoadingButton type="submit" appearance="danger" isLoading={submitting} onClick={onSubmit}>Unlink incident</LoadingButton>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default ConfirmationView;
